module.exports = __webpack_public_path__ + "media/images/icon_room_member_top-4c4049e2d7f1d7045d9c29847a33b82f.svg";